import { render, staticRenderFns } from "./SideInfo.vue?vue&type=template&id=e920c936&scoped=true"
import script from "./SideInfo.vue?vue&type=script&lang=js"
export * from "./SideInfo.vue?vue&type=script&lang=js"
import style0 from "./SideInfo.vue?vue&type=style&index=0&id=e920c936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e920c936",
  null
  
)

export default component.exports